import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';
import RmToolTip from './rmToolTip';
import { Grid, Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import GlobalFunction from './globalFunction';
import './css/clockModule.css';

const DEFAULT_OTHER_CONFIG = {
    topColour: '', topBackground: '',
    middleColour: '', middleBackground: '',
    bottomColour: '', bottomBackground: '',
    errorCount: 0,
};

const DEFAULT_ERRORS = {
    topColour: null, topBackground: null,
    middleColour: null, middleBackground: null,
    bottomColour: null, bottomBackground: null,
};

export default function ClockEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [bStyle, setBStyle] = useState(eventModuleRow.colour ?? '');
    const [other_config, setOtherConfig] = useState(
        eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 7
            ? eventModuleRow.other_config
            : DEFAULT_OTHER_CONFIG
    );
    const [errors, setErrors] = useState(DEFAULT_ERRORS);

    useEffect(() => {
        setBStyle(eventModuleRow.colour);
        if (eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 7) {
            setOtherConfig(eventModuleRow.other_config);
        }
    }, [eventModuleRow]);

    function isColor(strColor) {
        const s = new Option().style;
        s.color = strColor;
        return s.color.length > 0;
    }

    function handleChange(e) {
        const newErrors = { ...errors };
        if (e.target.value.length === 0) {
            newErrors[e.target.name] = null;
        } else {
            newErrors[e.target.name] = isColor(e.target.value) ? 'success' : 'error';
        }
        const errorCount = Object.values(newErrors).filter(v => v === 'error').length;
        const newConfig = { ...other_config, [e.target.name]: e.target.value, errorCount };

        setOtherConfig(newConfig);
        setErrors(newErrors);
        updateEventModuleRow({
            name: '',
            colour: bStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            other_config: newConfig,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        updateEventModuleRow({
            name: '',
            colour: newStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            other_config,
        });
    }

    const colourStyle = { paddingLeft: '5px', paddingRight: '5px' };

    let burgerColor = GlobalFunction.getPaletteColour(bStyle);
    if (other_config.middleColour.length > 0) burgerColor = other_config.middleColour;

    let burgerBackground = '';
    if (other_config.middleBackground.length > 0) burgerBackground = other_config.middleBackground;

    const burgerStyle = {
        height: '60px', fontSize: '40px',
        lineHeight: '60px', width: '200px', textAlign: 'center',
        marginLeft: 0, marginRight: 0,
        color: burgerColor, backgroundColor: burgerBackground,
    };

    const bunStyle = {
        height: '30px', fontSize: '17px',
        lineHeight: '30px', width: '200px',
        marginLeft: 0, marginRight: 0,
    };

    const bottomBunStyle = {
        height: '30px', lineHeight: '30px', width: '200px',
        fontSize: '28px', whiteSpace: 'nowrap',
        marginLeft: '0', marginRight: '0',
        paddingLeft: '0', paddingRight: '0',
    };

    let currentTimeColour = GlobalFunction.getPaletteColour(bStyle) + '66';
    if (other_config.topColour.length > 0) currentTimeColour = other_config.topColour;

    let currentTimeBackgroundColour = '';
    if (other_config.topBackground.length > 0) currentTimeBackgroundColour = other_config.topBackground;

    const currentTimeStyle = {
        textAlign: 'center',
        paddingLeft: '10px', paddingRight: '10px',
        backgroundColor: currentTimeBackgroundColour,
        color: currentTimeColour,
    };

    let bottomTimeColour = GlobalFunction.getPaletteColour(bStyle) + '66';
    if (other_config.bottomColour.length > 0) bottomTimeColour = other_config.bottomColour;

    let bottomTimeBackgroundColour = '';
    if (other_config.bottomBackground.length > 0) bottomTimeBackgroundColour = other_config.bottomBackground;

    const bottomTimeStyle = {
        textAlign: 'center', paddingLeft: '0px', paddingRight: '0px',
        backgroundColor: bottomTimeBackgroundColour,
        color: bottomTimeColour,
    };

    return (
        <div>
            <Grid>
                <Row>
                    <Col xs={2}>Default Colour</Col>
                    <Col xs={4}>
                        <SelectColourButton
                            title="Select Colour"
                            groupingSequence={eventModuleRow.event_grouping_seq}
                            selectedColour={colourSelected}
                            bStyle={bStyle} />
                    </Col>
                    <Col xs={2} />
                </Row>
                <br />
                <Row>
                    <Col xs={2}>
                        <strong>Colour Override</strong>{' '}
                        <RmToolTip itemText="help"
                            itemType="icon"
                            style={{ position: 'absolute', top: 0, right: 0, fontSize: '22px', color: 'orangered', cursor: '' }}
                            placement="bottom"
                            noClick={true}
                            toolTipText={<span>
                                You can override<br />
                                some or all of<br />
                                the default colours<br />
                                according to the row
                            </span>} />
                    </Col>
                    <Col xs={2}>Text Colour</Col>
                    <Col xs={2}>Background Color</Col>
                </Row>
                <Row>
                    <Col xs={2}>Top Row</Col>
                    <Col xs={2}>
                        <FormGroup controlId="topColour" validationState={errors.topColour} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="topColour"
                                autoFocus={false} value={other_config.topColour}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                    <Col xs={2}>
                        <FormGroup controlId="topBackground" validationState={errors.topBackground} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="topBackground"
                                autoFocus={false} value={other_config.topBackground}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>Middle Row</Col>
                    <Col xs={2}>
                        <FormGroup controlId="middleColour" validationState={errors.middleColour} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="middleColour"
                                autoFocus={false} value={other_config.middleColour}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                    <Col xs={2}>
                        <FormGroup controlId="middleBackground" validationState={errors.middleBackground} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="middleBackground"
                                autoFocus={false} value={other_config.middleBackground}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>Bottom Row</Col>
                    <Col xs={2}>
                        <FormGroup controlId="bottomColour" validationState={errors.bottomColour} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="bottomColour"
                                autoFocus={false} value={other_config.bottomColour}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                    <Col xs={2}>
                        <FormGroup controlId="bottomBackground" validationState={errors.bottomBackground} style={{ width: '100%' }}>
                            <FormControl type="text" placeholder="Colour" name="bottomBackground"
                                autoFocus={false} value={other_config.bottomBackground}
                                onChange={handleChange} style={colourStyle} />
                            <FormControl.Feedback />
                        </FormGroup>
                    </Col>
                </Row>
                <br /><br />
                <div style={{ width: '300px', height: '180px', backgroundColor: '#333333', paddingLeft: '50px', paddingTop: '30px' }}>
                    <div style={bunStyle}>
                        <span style={currentTimeStyle}>
                            Monday 1st Jan 2000
                        </span>
                    </div>
                    <div style={burgerStyle}>
                        <span className="clockModule-timeInWords">
                            Midday
                        </span>
                    </div>
                    <div style={bottomBunStyle}>
                        <div style={bottomTimeStyle}>
                            <span style={{ textAlign: 'right' }}>12</span>
                            :
                            <span style={{ display: 'inline-block' }}>00</span>
                            :
                            <span style={{ display: 'inline-block', textAlign: 'left' }}>00</span>
                            pm
                        </div>
                    </div>
                </div>
            </Grid>
        </div>
    );
}
